import { Dealer, PreferenceType } from '../dealer.types';
import { getDesignSystemIcon } from '@phoenix/design-system/frontend/util/path.utils';

export const formatDistance = (meters: number, country: string, unit: string) => {
  let distance = meters / 1000; // default to kilometers

  if (country?.toLowerCase() === 'us') {
    // convert meters to miles for US
    distance = meters / 1609.34;
  }

  return `${distance.toFixed(2)} ${unit}`;
};

export const WEEKDAY = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'][new Date().getDay()];

export const sortDealersByDistance = (dealers: Dealer[]) => {
  return dealers.sort((dealerA, dealerB) => {
    if (dealerA.location?.distanceMeters === dealerB.location?.distanceMeters) {
      return dealerA.id.localeCompare(dealerB.id);
    }
    return dealerA.location?.distanceMeters - dealerB.location?.distanceMeters;
  });
};

export const sortDealersByDescription = (dealers: Dealer[], mainAlwaysFirst = true) => {
  return dealers.sort((dealerA, dealerB) => {
    if ((mainAlwaysFirst && dealerA.preference?.type) || dealerB.preference?.type) {
      if (dealerA.preference?.type === PreferenceType.MAIN) {
        return -1;
      }
      if (dealerB.preference?.type === PreferenceType.MAIN) {
        return 1;
      }
    }

    if (dealerA.description === dealerB.description) {
      return dealerA.id.localeCompare(dealerB.id);
    }
    return dealerA.description.localeCompare(dealerB.description);
  });
};

export const getDealerIcon = (dealer: Dealer | undefined, isSelected: boolean): string => {
  const iconType = dealer?.preference?.type;
  const selectedSuffix = isSelected ? '-selected' : '';

  let iconPrefix: string;
  if (!dealer) {
    iconPrefix = 'regular';
  } else {
    switch (iconType) {
      case PreferenceType.FAVORITE:
        iconPrefix = 'favorite';
        break;
      case PreferenceType.MAIN:
        iconPrefix = 'main';
        break;
      default:
        iconPrefix = 'regular';
    }
  }

  return getDesignSystemIcon(`icon-pin-${iconPrefix}-dealer-fixed${selectedSuffix}.svg`);
};
